module.exports = __webpack_public_path__ + "static/Monica-Landoni-cde0532dc77b3fe96203ed030fbc07b8.png";